import { render } from "./ServiceItsAdvancedTechComp.vue?vue&type=template&id=bc268002&scoped=true"
import script from "./ServiceItsAdvancedTechComp.vue?vue&type=script&lang=js"
export * from "./ServiceItsAdvancedTechComp.vue?vue&type=script&lang=js"

import "./ServiceItsAdvancedTechComp.vue?vue&type=style&index=0&id=bc268002&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc268002"]])

export default __exports__